import { memo, useMemo } from 'react';

import CustomCollapse from 'components/collapse/CustomCollapse';
import {
  CollapseWrapper,
  FilterWrapper,
  ItemWrapper,
  MainTitle,
} from 'components/filter-panel/style';
import { useFilterPanel } from 'components/filter-panel/useFilterPanel';
import MultiSelectCheckbox, { OptionType } from 'components/select/MultiSelectCheckbox';
import { Checkbox, Row, Typography } from 'enable-ui';

import { FilterConfig, FilterPanelProps } from 'components/filter-panel/type';

import { COLOR } from 'constants/color';

const FilterPanel = ({ items, onFilterChange, loadMoreHandlers, onSearch }: FilterPanelProps) => {
  const {
    selectedFilters,
    handleCheckboxSelect,
    handleMultiSelectChange,
    handleSearchChange,
    searchTerms,
    toggleCollapse,
    openCollapseKeys,
  } = useFilterPanel(items, onFilterChange, onSearch);

  const renderFilterOptions = useMemo(
    () => (
      <CollapseWrapper>
        {items.map((item: FilterConfig) => (
          <article style={{ marginBottom: 32 }}>
            <Typography
              variant="body-3"
              weight={600}
              color={COLOR.surfaceNeutralBold['neutral-11']}
              style={{ marginBottom: 12 }}
            >
              {item.title}
            </Typography>
            {/* <CustomCollapse
            key={item.key}
            title={item.title}
            onToggle={toggleCollapse(item.key)}
            extraContainerClass="custom-collapse"
            isOpen={openCollapseKeys[item.key] || false}
          > */}
            <ItemWrapper>
              {item.options.map((option) => {
                const optionType = option.type || 'checkbox';
                const loadMoreKey = option.loadMoreKey;
                const handler = loadMoreKey ? loadMoreHandlers?.[loadMoreKey] : null;

                return optionType === 'selectable' ? (
                  <MultiSelectCheckbox
                    key={option.id}
                    placeholder={option.label}
                    options={option.options as OptionType[]}
                    selectedValues={selectedFilters[item.key] || []}
                    onChange={handleMultiSelectChange(item.key)}
                    fetchMoreData={handler?.loadMore}
                    hasMore={handler?.hasMore || false}
                    isLoading={handler?.isLoading || false}
                    searchTerm={searchTerms[item.key] || ''}
                    onSearch={handleSearchChange(item.key)}
                    inputPlaceholder={option.placeholder}
                    localSearch={option.localSearch}
                  />
                ) : (
                  <Row
                    key={option.id}
                    align="center"
                    className="cursor-pointer"
                    onClick={handleCheckboxSelect(item.key, option.id)}
                  >
                    <Checkbox
                      onClick={handleCheckboxSelect(item.key, option.id)}
                      checked={(selectedFilters[item.key] || []).includes(option.id)}
                    />
                    <Typography
                      style={{ marginLeft: 8, maxWidth: 164 }}
                      variant="body-2"
                      className="ellipsis"
                      color={COLOR.surfaceNeutralBold['neutral-11']}
                    >
                      {option.label}
                    </Typography>
                  </Row>
                );
              })}
            </ItemWrapper>
          </article>
          // </CustomCollapse>
        ))}
      </CollapseWrapper>
    ),
    [items, selectedFilters, handleCheckboxSelect, handleMultiSelectChange],
  );

  return (
    <FilterWrapper>
      <MainTitle className="mb-24">Filter</MainTitle>
      {/* <TextInput
        value={searchTerm}
        prefix={<SearchIcon />}
        onChange={handleSearchChange}
        placeholder="Search classes, users, and centers"
      /> */}
      {renderFilterOptions}
    </FilterWrapper>
  );
};

export default memo(FilterPanel);
